/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FocoosTask } from '../../models/focoos-task';
import { ModelPreview } from '../../models/model-preview';

export interface ListFocoosModels$Params {
  includeMetrics?: boolean | null;
  taskFilter?: FocoosTask;
}

export function listFocoosModels(http: HttpClient, rootUrl: string, params?: ListFocoosModels$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ModelPreview>>> {
  const rb = new RequestBuilder(rootUrl, listFocoosModels.PATH, 'get');
  if (params) {
    rb.query('includeMetrics', params.includeMetrics, {});
    rb.query('taskFilter', params.taskFilter, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ModelPreview>>;
    })
  );
}

listFocoosModels.PATH = '/v0/FocoosAI/focoos-models';
